import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GameBoard.css';

const GameBoard = ({ catImage, backgroundImage, nextLevel, catPosition }) => {
  const navigate = useNavigate();
  const [transitioning, setTransitioning] = useState(false);

  const handleStartClick = () => navigate('/');

  const handleCatClick = () => {
    const sound = new Audio('/sounds/level-passed.mp3');
    sound.volume = 0.3;
    sound.play().catch((e) => console.error("Audio play error:", e));

    setTransitioning(true);

    setTimeout(() => {
      navigate(nextLevel);
    }, 1000); // Match with animation duration
  };

  return (
    <div className="game-container">
      <button className="corner-button" onClick={handleStartClick}>Give up</button>

      <div className="image-wrapper">
        <img
          className="background-image"
          src={backgroundImage}
          alt="Background"
        />
        <img
          className="cat-image"
          src={catImage}
          alt="Cat"
          onClick={handleCatClick}
          style={{
            top: catPosition.y,
            left: catPosition.x
          }}
        />
      </div>

      {transitioning && <div className="circle-mask" />}
    </div>
  );
};

export default GameBoard;
